<ng-container *ngIf="employment$ | async as employment">
  <div
    class="count-item"
    [class.inactive]="(counts$ | async)?.open === 0"
    [matTooltip]="'waiting' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="waiting-clock-circle-filled"
      class="size-16 count-icon pending-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-pending-count">
      {{ (counts$ | async)?.open }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="(counts$ | async)?.unavailable === 0"
    [matTooltip]="'declined' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="not-available-busy-circle-filled"
      class="size-16 count-icon not-available-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-unavailable-count">
      {{ (counts$ | async)?.unavailable }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="(counts$ | async)?.available === 0"
    [matTooltip]="'available' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="available-check-circle-filled"
      class="size-16 count-icon available-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-available-count">
      {{ (counts$ | async)?.available }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="(counts$ | async)?.booked === 0"
    [matTooltip]="'booked' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="booked-star-circle-filled"
      class="size-16 count-icon booked-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-booked-count">
      {{ (counts$ | async)?.booked }} /
      {{ employment.requiredUsers }}
    </div>
  </div>
</ng-container>
